import { Container } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { ProgressStepsItem } from "./ProgressStepsItem";
import type { ProgressStepsProps } from "./types";
import "./ProgressSteps.css";

export const ProgressSteps = ({
  ref,
  ...props
}: WithMetadata<ProgressStepsProps>) => {
  const { className, steps, componentName, ...otherProps } = props;
  const { variant } = otherProps;

  if (!steps) {
    console.warn("ProgressSteps will not render. Prop steps is empty.");
    return null;
  }

  const classes = classNames("mobius", "mobius-progress-steps", className);
  const itemCount = steps.length;
  const activeStep = steps.find(step => step.isActive);

  return (
    <Container
      size="sm"
      elementType="ol"
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
      style={{ gridTemplateColumns: `repeat(${itemCount}, 1fr)` }}
    >
      {steps.map((step, index) => (
        <ProgressStepsItem
          key={step.name}
          index={index + 1}
          activeIndex={activeStep?.index}
          activeName={activeStep?.name}
          {...step}
        />
      ))}
    </Container>
  );
};

ProgressSteps.displayName = "ProgressSteps";
